import { inject } from '@angular/core';
import { CanActivateFn, Router, UrlTree } from '@angular/router';
import { FeatureFlag } from '@repo/models';
import { combineLatest, map, type Observable } from 'rxjs';
import { PosthogService } from 'src/services/posthog.service';

/**
 * Blocks `/menu-offers` when both deals and upgrades PostHog flags are off (direct URL, bookmarks).
 * Aligns with app shell nav: `skip(1)` matches first reliable evaluation after feature flags load.
 */
export const menuOffersAccessGuard: CanActivateFn = (): Observable<boolean | UrlTree> => {
  const posthog = inject(PosthogService);
  const router = inject(Router);

  return combineLatest([
    posthog.observeFeatureEnabled(FeatureFlag.MenuDealsEnabled).pipe(),
    posthog.observeFeatureEnabled(FeatureFlag.MenuUpgradesEnabled).pipe(),
  ]).pipe(
    map(([dealsEnabled, upgradesEnabled]) => {
      if (dealsEnabled || upgradesEnabled) {
        return true;
      }
      return router.createUrlTree(['/']);
    })
  );
};
